<nav class="sidebar sidebar-offcanvas" id="sidebar"
    style="border-right: 1px solid #9c9fa6; height: 100%; position: fixed; padding-top: 140px; overflow-y: scroll;">
    <ul class="nav">
        <li class="nav-item">

            <a class="nav-link" routerLink="/Dashboard">
                <img src="../../assets/navIcon/Dashboard.png" />&nbsp;&nbsp;
                <span class="menu-title">Dashboard</span>

            </a>
        </li>
        <li class="nav-item" [hidden]="ShownAudit">
            <a class="nav-link menu-item2" data-toggle="collapse" aria-expanded="false" aria-controls="ui-basic">
                <img src="../../assets/navIcon/Audit.png" />&nbsp;&nbsp;
                <span class="menu-title">Audit</span>
                <i class="menu-arrow"></i>
                <i class="mdi mdi-crosshairs-gps menu-icon"></i>
            </a>
            <div class="collapse" id="ui-basic1">
                <ul class="nav flex-column sub-menu">

                    <li class="nav-item"> <a class="nav-link" routerLink="/readPNR"
                            [hidden]="ShownAuditFilrUpload">Upload</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/Output"
                            [hidden]="ShownAuditFilrOutput">Output</a></li>
                </ul>
            </div>
        </li>

        <!-- <li class="nav-item">
                    <a class="nav-link" routerLink="/readPNR">
                        <img src="../../assets/navIcon/Audit.png"  />&nbsp;&nbsp;
                        <span class="menu-title">Audit</span>
                        <i class="mdi mdi-contacts menu-icon"></i>
                    </a>
                </li> -->
        <li class="nav-item" [hidden]="ShownClientFileUpload">
            <a class="nav-link" routerLink="/ClientUpload">
                <img src="../../assets/navIcon/ClientUpload.png" />&nbsp;&nbsp;
                <span class="menu-title">Client Upload</span>
                <i class="mdi mdi-contacts menu-icon"></i>
            </a>
        </li>
        <!-- <li class="nav-item">
                    <a class="nav-link" href="../forms/basic_elements.html">
                        <img src="../../assets/navIcon/License.png"  />&nbsp;&nbsp;
                        <span class="menu-title">licence</span>
                        <i class="mdi mdi-format-list-bulleted menu-icon"></i>
                    </a>
                </li> -->


        <li class="nav-item">
            <a class="nav-link menu-item1" data-toggle="collapse" aria-expanded="false" aria-controls="ui-basic">
                <img src="../../assets/navIcon/Master.png" />&nbsp;&nbsp;
                <span class="menu-title">Master</span>
                <i class="menu-arrow"></i>
                <i class="mdi mdi-crosshairs-gps menu-icon"></i>
            </a>
            <div class="collapse" id="ui-basic">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item"> <a class="nav-link" routerLink="/onboarding"
                            [hidden]="ShownOnboarding">Onboarding</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/Contracts"
                            [hidden]="ShownContracts">Contracts</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/NDA" [hidden]="ShownNDA">NDA</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/Employee"
                            [hidden]="ShownEmployee">Employee</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/AssignEmp" [hidden]="ShownAssignEmp">Assign
                            Employee</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/Parts" [hidden]="ShownParts">Parts</a></li>
                    <!-- <li class="nav-item"> <a class="nav-link" routerLink="/License" [hidden]="ShownLicence">Licence</a>
                    </li> -->
                    <li class="nav-item"> <a class="nav-link" routerLink="/LicenseMEIS">Licence-MEIS</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/LicenseAAS">Licence-AAS</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/Bond" [hidden]="ShownBond">Bond</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/Bank" [hidden]="ShownBank">Bank Gaurantee</a>
                    </li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/ImportCSV" [hidden]="ShownImportPart">Import
                            Part Master</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/UserRights" [hidden]="ShownUserRights">User
                            Rights</a></li>
                            <li class="nav-item"> <a class="nav-link" routerLink="/units-master" >Units</a></li>
                </ul>
            </div>
        </li>
        <li class="nav-item" [hidden]="ShownChaMaster">
            <a class="nav-link" routerLink="/Chamaster">
                <img src="../../assets/navIcon/CHA.png" />&nbsp;&nbsp;
                <span class="menu-title">CHA</span>
                <i class="mdi mdi-format-list-bulleted menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" [hidden]="ShownCountryMaster">
            <a class="nav-link" routerLink="/countrymaster">
                <img src="../../assets/navIcon/Country.png" />&nbsp;&nbsp;
                <span class="menu-title">Country</span>
                <i class="mdi mdi-format-list-bulleted menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" [hidden]="ShownCurrencyMaster">
            <a class="nav-link" routerLink="/currencymaster">
                <img src="../../assets/navIcon/Currecny.png" />&nbsp;&nbsp;
                <span class="menu-title">Currency</span>
                <i class="mdi mdi-format-list-bulleted menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" [hidden]="ShownExchangeMaster">
            <a class="nav-link" routerLink="/Exchange">
                <img src="../../assets/navIcon/EchangeRate.png" />&nbsp;&nbsp;
                <span class="menu-title">Exchange Rate</span>
                <i class="mdi mdi-format-list-bulleted menu-icon"></i>
            </a>
        </li>
        <li class="nav-item" [hidden]="ShownPortMaster">
            <a class="nav-link" routerLink="/Portmaster">
                <img src="../../assets/navIcon/PortIcon.png" />&nbsp;&nbsp;
                <span class="menu-title">Port</span>
                <i class="mdi mdi-format-list-bulleted menu-icon"></i>
            </a>
        </li>

        <li class="nav-item" [hidden]="ShownNotify">
            <a class="nav-link menu-item3" data-toggle="collapse" aria-expanded="false" aria-controls="ui-basic">
                <img src="../../assets/navIcon/Notification.png" />&nbsp;&nbsp;
                <span class="menu-title">Notifications</span>
                <i class="menu-arrow"></i>
                <i class="mdi mdi-crosshairs-gps menu-icon"></i>
            </a>
            <div class="collapse" id="ui-basic2">
                <ul class="nav flex-column sub-menu">

                    <li class="nav-item"> <a class="nav-link" routerLink="/Customnotify"
                            [hidden]="ShownCustoms">Customs</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/Exim" [hidden]="ShownExim">Exim</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/Antidumping"
                            [hidden]="ShownAntiDumping">AntiDumping</a></li>
                </ul>
            </div>
        </li>
        <li class="nav-item" [hidden]="ShownReport">
            <a class="nav-link menu-item4" data-toggle="collapse" aria-expanded="false" aria-controls="ui-basic">
                <img src="../../assets/navIcon/Audit.png" />&nbsp;&nbsp;
                <span class="menu-title">Report</span>
                <i class="menu-arrow"></i>
                <i class="mdi mdi-crosshairs-gps menu-icon"></i>
            </a>
            <div class="collapse" id="ui-basic3">
                <ul class="nav flex-column sub-menu">

                    <li class="nav-item"> <a class="nav-link" routerLink="/AuditReport"
                            >Audit Output</a></li>
                    
                </ul>
            </div>
        </li>
        <!-- <li class="nav-item">
                    <a class="nav-link">
                        <img src="../../assets/navIcon/Terms&Conditions.png"  />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">Terms & Conditions</span>

                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link">
                        <img src="../../assets/navIcon/Copyrigths.png"  />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">CopyRights</span>

                    </a>
                </li> -->

        <li class="nav-item">
            <a class="nav-link" (click)="LogoutClick()">
                <img src="../../assets/navIcon/Logout.png" />&nbsp;&nbsp;
                <span class="menu-title" style="font-size:13px;">LogOut</span>

            </a>
        </li>

    </ul>
</nav>

<!-- partial:../../partials/_navbar.html -->
<nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;">
    <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
        style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;width: 260px;height: 140px;">
        <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
        <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        <!-- <img src="../../assets/eye.png" style="padding-top: 35px;" /> -->
    </div>
</nav>

<div class="row" style="padding-left: 266px; padding-top: 10px; position: fixed; height:50px !important; text-align: right; width: 100%; padding-right: 20px;border-bottom: 1px solid #9c9fa6; background-color: white; ">   
    <div class="col-lg-4" style="text-align: left;">
        <span id="Rolename">{{Rolename}} : </span> 
        <label id="Username" style="padding-right: 52%;padding-left: none;">{{Username}}</label>
    </div> 
    <div class ="col-lg-8">
        <label>{{corporateName}}</label>
        &nbsp;&nbsp;
        <label>Customer</label><span style="color: red;">*</span>&nbsp;&nbsp;
        <select class="" [(ngModel)]="onboardingId" (change)="Show($event)"
            style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ; width: 250px;">
            <option value="0" disabled>Select A Customer</option>
            <option *ngFor="let cs of Customers" value={{cs.onboardingId}}>{{cs.customerCode}}
            </option>
        </select>
    </div>
</div>